<template>
  <div class="big-map-box">
    <div class="map-content" :id="id"></div>
    <div class="map-darkcorner"></div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'Transfermap',
  props: {
    title: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: "transferMap"
    },
    zoom: {
      type: Number,
      default: 5
    },
    legendColor: {
      type: Array
    },
    chartData: {
      type: Object,
      default() {
        return {
          curArea: '河南',
          curCenter: [113.814572, 33.871112],
          sourceArea: [
            {
              name: '广东',
              coordinate: [113.354639, 23.137368],
              num: '9000'
            },
            {
              name: '四川',
              coordinate: [104.119196, 30.555997],
              num: '7000'
            },
            {
              name: '江苏',
              coordinate: [118.801748, 32.063839],
              num: '5000'
            },
            {
              name: '湖南',
              coordinate: [112.94591, 28.237483],
              num: '3000'
            },
            {
              name: '浙江',
              coordinate: [120.211279, 30.255079],
              num: '1000'
            },
            {
              name: '山东',
              coordinate: [117.126902, 36.65633],
              num: '7200'
            },
            {
              name: '湖北',
              coordinate: [114.310499, 30.599358],
              num: '4500'
            },
            {
              name: '甘肃',
              coordinate: [103.839949, 36.064999],
              num: '3200'
            }
          ]
        }
      }
    }
  },
  data() {
    return {
      chart: null,
      map: null,
      curMap: 0
    }
  },
  mounted() {
    this.initChart()
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      // 先根据value洗颜色和symbol大小
      for (let i = 0; i < this.chartData.sourceArea.length; i++) {
        if(!this.chartData.sourceArea[i].hasOwnProperty('coordinate')) {
          continue
        }
        if (this.chartData.sourceArea[i].num >= this.chartData.legendConf[0].min) {
          this.chartData.sourceArea[i].symbolSize = 14
          this.chartData.sourceArea[i].color = this.legendColor[0]
        } else if (
          this.chartData.sourceArea[i].num >= this.chartData.legendConf[1].min
        ) {
          this.chartData.sourceArea[i].symbolSize = 12
          this.chartData.sourceArea[i].color = this.legendColor[1]
        } else if (
          this.chartData.sourceArea[i].num >= this.chartData.legendConf[2].min
        ) {
          this.chartData.sourceArea[i].symbolSize = 10
          this.chartData.sourceArea[i].color = this.legendColor[2]
        } else if (
          this.chartData.sourceArea[i].num >= this.chartData.legendConf[3].min
        ) {
          this.chartData.sourceArea[i].symbolSize = 8
          this.chartData.sourceArea[i].color = this.legendColor[3]
        } else if (
          this.chartData.sourceArea[i].num >= this.chartData.legendConf[4].min
        ) {
          this.chartData.sourceArea[i].symbolSize = 6
          this.chartData.sourceArea[i].color = this.legendColor[4]
        }
      }

      // 洗series
      var series = []
      for (let i = 0; i < this.chartData.sourceArea.length; i++) {
        if(!this.chartData.sourceArea[i].hasOwnProperty('coordinate')) {
          continue
        }
        series.push({
          name: this.chartData.sourceArea[i].name,
          coordinateSystem: 'amap',
          type: 'lines',
          zlevel: 3,
          effect: {
            show: true,
            period: 6,
            shadowBlur: 4,
            trailLength: 0.4,
            opacity: 0.4,
            color: '#cbeeff',
            symbolSize: 4
          },
          lineStyle: {
            normal: {
              color: this.chartData.sourceArea[i].color,
              width: 0,
              curveness: 0.2
            }
          },
          data: [
            {
              fromName: this.chartData.curArea,
              toName: this.chartData.sourceArea[i].name,
              coords: [
                this.chartData.sourceArea[i].coordinate,
                this.chartData.curCenter
              ],
              value: this.chartData.sourceArea[i].value
            }
          ]
        })
        series.push({
          name: this.chartData.sourceArea[i].name,
          coordinateSystem: 'amap',
          type: 'lines',
          zlevel: 2,
          lineStyle: {
            normal: {
              color: this.chartData.sourceArea[i].color,
              width: 2,
              opacity: 0.8,
              curveness: 0.2,
              shadowColor: this.chartData.sourceArea[i].color,
              shadowBlur: 10,
            }
          },
          data: [
            {
              fromName: this.chartData.curArea,
              toName: this.chartData.sourceArea[i].name,
              coords: [
                this.chartData.sourceArea[i].coordinate,
                this.chartData.curCenter
              ],
              value: this.chartData.sourceArea[i].value
            }
          ]
        })
        series.push({
          name: this.chartData.sourceArea[i].name,
          type: 'effectScatter',
          coordinateSystem: 'amap',
          zlevel: 4,
          symbol: 'circle',
          symbolSize: this.chartData.sourceArea[i].symbolSize,
          rippleEffect: {
            scale: 8,
            period: 6,
            brushType: 'fill'
          },
          label: {
            normal: {
              show: true,
              position: 'bottom',
              formatter: () => {
                return this.chartData.sourceArea[i].name + ' ' + this.chartData.sourceArea[i].num
              },
              color: '#cbeeff'
            }
          },
          itemStyle: {
            normal: {
              color: this.chartData.sourceArea[i].color
            }
          },
          data: [
            {
              name: this.chartData.sourceArea[i].name,
              value: this.chartData.sourceArea[i].coordinate
            }
          ]
        })
      }

      this.chart = this.$echarts.init(document.getElementById(this.id))
      this.chart.setOption({
        amap: {
          zoom: this.zoom,
          zooms: [4, 10],
          mapStyle: 'amap://styles/b5500447492ee5d38f79824b6e68aec4',
          center: this.chartData.curCenter, //中心点
          rotation: 0, //顺时针旋转角度
          resizeEnable: true
        },
        animation: false,
        series: []
      })

      this.map = this.chart
        .getModel()
        .getComponent('amap')
        .getAMap()

      this.chart.setOption({
        series: series
      })
    }
  }
}
</script>

<style scoped lang="less"></style>
